// extracted by mini-css-extract-plugin
module.exports = {"loanLimitProgressBar":"LoanLimitProgressBar_loanLimitProgressBar__1XCI6","emptyBar":"LoanLimitProgressBar_emptyBar__B6Dc9","description":"LoanLimitProgressBar_description__3zZ31"};